export default "__VITE_ASSET__b5b139bd__"